module.exports = __webpack_public_path__ + "0fd03c905f2016fadaefcfa2cb6c434e.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/gamecenter/vn/luckyfruit.jpg
// module id = 648
// module chunks = 30